import React, { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import Select from 'react-select';
import { useIntl } from 'react-intl';

const CustomSelect = ({ name, value, optionArray, label, error, register, required, iconClass, change, showErrorMessage = true, classError, customClassLabel = '' }) => {
  const translate = useIntl();
  const changeError = (typeError) => {
    if (typeError === 'required') {
      return translate.formatMessage({ id: 'acc.field-required' });
    } if (typeError === 'pattern') {
      return translate.formatMessage({ id: 'acc.email-required' });
    }
    return '';
  };
  const customLabelClass = `${required ? 'required' : ''} input__label ${customClassLabel}`;
  const cssImage = `def ${iconClass}`;
  const classInput = `${error ? `error ${classError}` : ''}`;
  return (
    <div className="input">
      {label && <label className={customLabelClass}>{label}</label>}
      {iconClass && <i className={cssImage} />}
      <select className={classInput} name={name} defaultValue={value} ref={register} onChange={change}>
        {/* eslint-disable-next-line react/no-array-index-key */}
        {optionArray.map((el, index) => <option key={index + el.value} value={el.value}>{el.label}</option>)}
      </select>
      {error && showErrorMessage && <div className="input__error">{changeError(error.type)}</div>}
    </div>
  );
};

const CustomReactSelect = forwardRef(({
  wrapperClass = '',
  inputClass = '',
  titleClass = '',
  selectStyles = {},
  placeholder = '',
  labelText = '',
  options = [],
  selectOnChange = () => {},
  tooltip,
  name,
  defaultValue = null,
  control,
  rules,
  error,
  disabled = false,
  isClearable = true,
}, ref) => {
  const translate = useIntl();
  const customStyles = {
    control: (styles) => ({
      ...styles,
      padding: 10,
      fontSize: 14,
      lineHeight: 1.7,
      color: '#5b6075',
      borderRadius: 8,
      backgroundColor: 'white',
      border: `1px solid ${error ? '#ff0000' : '#d5d9e7'}`,
      boxShadow: 0,
      cursor: 'pointer',
      '&:hover': {
        boxShadow: 'none',
      },
    }),
    valueContainer: (styles) => ({
      ...styles,
      padding: 0,
      fontSize: 14,
      lineHeight: 1.7,
    }),
    placeholder: (styles) => ({
      ...styles,
      margin: 0,
      fontSize: 14,
      lineHeight: 1.7,
      fontWeight: 400,
      color: '#CFD6E4',
    }),
    singleValue: (styles) => ({
      ...styles,
      margin: 0,
      fontSize: 14,
      lineHeight: 1.7,
      fontWeight: 400,
      color: '#5b6075',
    }),
    dropdownIndicator: (styles, { selectProps: { menuIsOpen } }) => ({
      ...styles,
      padding: 0,
      transform: menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      color: '#d5d9e7',
      svg: {
        width: 24,
        height: 24,
      },
    }),
    clearIndicator: (styles) => ({
      ...styles,
      padding: 0,
      color: '#d5d9e7',
    }),
    menu: (styles) => ({
      ...styles,
      marginTop: 8,
      padding: 0,
      borderRadius: 8,
      border: '1px solid #d5d9e7',
      boxShadow: 'none',
      zIndex: 20,
      top: '100%',
      display: 'block!important',
    }),
    menuList: (styles) => ({
      ...styles,
      paddingBottom: 0,
      paddingTop: 0,
      borderRadius: 8,

    }),
    option: (styles, { isFocused }) => ({
      ...styles,
      backgroundColor: isFocused ? 'rgba(50, 157, 156, 0.2);' : 'white',
      color: '#5b6075',
      fontSize: 14,
      lineHeight: 1.7,
      paddingLeft: 10,
      cursor: 'pointer',
      ':first-child': {
        borderTopLeftRadius: 8,
      },
      ':last-child': {
        borderBottomLeftRadius: 8,
      },

    }),
    ...selectStyles,
  };

  const getErrorText = (e) => {
    switch (e.type) {
      case 'required':
        return translate.formatMessage({ id: 'acc.field-required' });
      default:
        return 'Bad value';
    }
  };

  return (
    <div className={wrapperClass}>
      {labelText && (
        <div className={titleClass}>
          <span>{labelText}</span>
          {tooltip}
        </div>
      )}
      <div className={inputClass}>
        {control ? (
          <Controller
            name={name}
            control={control}
            rules={rules}
            defaultValue={defaultValue}
            render={(props) => (
              <Select
                isClearable={isClearable}
                isSearchable={false}
                isDisabled={disabled}
                closeMenuOnSelect
                placeholder={placeholder}
                options={options}
                styles={customStyles}
                defaultValue={defaultValue}
                value={props.value}
                ref={props.ref}
                onChange={(e) => {
                  props.onChange(e);
                  selectOnChange(e?.value);
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
              />
            )}
          />
        ) : (
          <Select
            ref={ref}
            isClearable
            isSearchable={false}
            closeMenuOnSelect
            placeholder={placeholder}
            options={options}
            styles={customStyles}
            onChange={(e) => selectOnChange(e?.value)}
            components={{
              IndicatorSeparator: () => null,
            }}
          />
        )}
        {error && <div className="input__error">{getErrorText(error)}</div>}
      </div>
    </div>
  );
});

export { CustomReactSelect };
export default CustomSelect;
